import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import { apiMomentDateFormat, apiMomentDateTimeFormat } from "../constants/apiMomentFormat";
export const RAILS_FORMAT = 'YYYY-MM-DD HH:mm:ss Z'; // export const DATEPICKER_FORMAT = 'YYYY-MM-DD h:mm A';
// export const STANDARD_DATETIME_FORMAT = 'MMM D, hh:mm a';

export const nextHour = () => {
  let date = new Date();
  date.setMinutes(date.getMinutes() + 60);
  date.setMinutes(0);
  date.setSeconds(0);
  return date;
};
export const toRailsFormat = date => {
  return !!date ? moment(date).format(RAILS_FORMAT) : null;
};
export const dateStepsThisWeek = () => {
  const date = moment().startOf('week');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 6), () => {
    if (date.add(1, 'days').isSameOrBefore(moment())) {
      result = [...result, date.format('DD/MM/YYYY')];
    }
  });

  return result;
};
export const dateStepsLastWeek = () => {
  const date = moment().subtract(1, 'week').startOf('week');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 6), () => {
    result = [...result, date.add(1, 'days').format('DD/MM/YYYY')];
  });

  return result;
};
export const dateStepsLastSevenDays = () => {
  const date = moment().subtract(6, 'days');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 6), () => {
    result = [...result, date.add(1, 'days').format('DD/MM/YYYY')];
  });

  return result;
};
export const dateStepsLastFortnight = () => {
  const date = moment().subtract(13, 'days');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 13), () => {
    result = [...result, date.add(1, 'days').format('DD/MM/YYYY')];
  });

  return result;
};
export const dateStepsLastThirtyDays = () => {
  const date = moment().subtract(30, 'days');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 15), () => {
    result = [...result, date.add(2, 'days').format('DD/MM/YYYY')];
  });

  return result;
};
export const dateStepsThisMonth = () => {
  const date = moment().startOf('month');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, moment().daysInMonth() / 2), () => {
    if (date.add(2, 'days').isSameOrBefore(moment())) {
      result = [...result, date.format('DD/MM/YYYY')];
    }
  });

  return result;
};
export const dateStepsLastMonth = () => {
  const date = moment().subtract(1, 'months').startOf('month');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, date.daysInMonth() / 2), () => {
    if (date.add(2, 'days').isBefore(moment().startOf('month'))) {
      result = [...result, date.format('DD/MM/YYYY')];
    }
  });

  return result;
};
export const dateStepsLast6Months = () => {
  const date = moment().subtract(5, 'months').startOf('month');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 5), () => {
    result = [...result, date.add(1, 'months').format('DD/MM/YYYY')];
  });

  return result;
};
export const dateStepsThisYear = () => {
  const date = moment().startOf('year');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 11), () => {
    if (date.add(1, 'months').isSameOrBefore(moment())) {
      result = [...result, date.format('DD/MM/YYYY')];
    }
  });

  return result;
};
export const dateStepsLastYear = () => {
  const date = moment().subtract(1, 'years').startOf('year');
  let result = [date.format('DD/MM/YYYY')];

  _.map(_.range(0, 11), () => {
    result = [...result, date.add(1, 'months').format('DD/MM/YYYY')];
  });

  return result;
};
export const getDateRangeKey = (dateRange, date) => {
  let resultKey = date.format("DD/MM/YYYY");

  _.transform(dateRange.steps, (result, step) => {
    if (moment(step, "DD/MM/YYYY").isBefore(moment(date, "DD/MM/YYYY"))) {
      resultKey = step;
    }

    return moment(step, "DD/MM/YYYY").isBefore(moment(date, "DD/MM/YYYY"));
  });

  if (moment(_.last(dateRange.steps), "DD/MM/YYYY").add(dateRange.unit.number, dateRange.unit.momentUnit).isBefore(moment(date, "DD/MM/YYYY"))) {
    resultKey = date.format("DD/MM/YYYY");
  }

  return resultKey;
};
export const getDateRangeStepsEveryDay = (originFrom, originTo) => {
  let from = _.cloneDeep(originFrom);

  let to = _.cloneDeep(originTo);

  const daysCount = to.diff(from, 'days') + 1;
  let result = [from.format('DD/MM/YYYY')];

  _.map(_.range(0, daysCount - 1), () => {
    result = [...result, from.add(1, 'days').format('DD/MM/YYYY')];
  });

  return result;
};
export const getDateRangeStepsEveryTwoDays = (originFrom, originTo) => {
  let from = _.cloneDeep(originFrom);

  let to = _.cloneDeep(originTo);

  const daysCount = to.diff(from, 'days') + 1;
  let result = [from.format('DD/MM/YYYY')];

  _.map(_.range(0, (daysCount - 1) / 2), () => {
    result = [...result, from.add(2, 'days').isBefore(to) ? from.format('DD/MM/YYYY') : to.format('DD/MM/YYYY')];
  });

  return result;
};
export const getDateRangeSteps = (originFrom, originTo) => {
  let from = _.cloneDeep(originFrom);

  let to = _.cloneDeep(originTo);

  const daysCount = to.diff(from, 'days') + 1;
  let result = [from.format('DD/MM/YYYY')];

  _.map(_.range(0, daysCount / (daysCount / 13)), () => {
    result = [...result, from.add(daysCount / 13, 'days').isBefore(to) ? from.format('DD/MM/YYYY') : to.format('DD/MM/YYYY')];
  });

  if (moment(_.last(result), "DD/MM/YYYY").isBefore(to) && _.last(result) !== to.format('DD/MM/YYYY')) {
    result = [...result, to.format('DD/MM/YYYY')];
  }

  return result;
};
export const toApiDateString = date => {
  return moment(date).tz('Australia/Adelaide').format(apiMomentDateFormat);
};
export const toApiDateTimeString = date => {
  return moment(date).tz('Australia/Adelaide').format(apiMomentDateTimeFormat);
};
export const toMomentFromTimeString = timeString => {
  return moment(timeString, 'HH:mm').tz('Australia/Adelaide');
};
export const toTimeStringFromMoment = time => {
  return moment(time).tz('Australia/Adelaide').format('HH:mm');
};